export default function CsharpSyllabus() {
  return (
    <h2>Csharp Syllabus</h2>
  );
}
